var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "modal-content-root d-flex flex-column overflow-hidden",
    "class": {
      'modal-content-root--flat-chrome': _vm.flatChrome || _vm.stitch,
      'modal-content-root--stitch': _vm.stitch,
      'modal-content-root--fill': _vm.fillHeight,
      'modal-content-root--immersive': _vm.immersive
    }
  }, [_vm.immersive ? _c('v-btn', {
    staticClass: "modal-immersive-close",
    attrs: {
      "icon": "",
      "disabled": _vm.closeDisabled,
      "aria-label": _vm.$translate('immersiveClose')
    },
    on: {
      "click": function click($event) {
        return _vm.$emit('close');
      }
    }
  }, [_c('v-icon', [_vm._v("mdi-close")])], 1) : _vm._e(), !_vm.hideHeader && !_vm.immersive ? _c('v-card-title', {
    staticClass: "modal-content-title flex-shrink-0 mb-0",
    "class": _vm.flatChrome || _vm.stitch ? 'modal-content-title--flat' : 'primary-ultralight-grey'
  }, [_c('span', {
    staticClass: "modal-content-title-inner text-h3 pl-1 text-truncate"
  }, [_vm._t("title"), _vm.helpContentId && _vm.uniqueIdExists ? _c('v-icon', {
    staticClass: "ml-4",
    attrs: {
      "left": ""
    },
    on: {
      "click": _vm.openHelp
    }
  }, [_vm._v("help_outline")]) : _vm._e()], 2)]) : _vm._e(), _c('v-card-text', {
    staticClass: "modal-content-body pa-0 min-height-0",
    "class": _vm.bodyClasses
  }, [_vm.stitch && _vm.$slots.rawcontent ? _c('div', {
    staticClass: "stitch-modal stitch-modal--split stitch-form general-settings-reference modal-stitch-raw"
  }, [_vm._t("rawcontent")], 2) : _vm._t("rawcontent", function () {
    return [_c('div', {
      staticClass: "modal-content-body-inner px-4 px-sm-6 pt-4 pb-8",
      "class": _vm.fillHeight ? 'w-100 h-100 min-height-0 d-flex flex-column flex-grow-1' : 'w-100'
    }, [_vm.stitch ? _c('div', {
      staticClass: "stitch-modal stitch-form general-settings-reference modal-stitch-shell"
    }, [_c('div', {
      staticClass: "stitch-modal__card modal-stitch-surface"
    }, [_vm._t("content")], 2)]) : _vm._t("content")], 2)];
  })], 2), !_vm.hideFooter && !_vm.immersive ? _c('div', {
    staticClass: "modal-content-bottom flex-shrink-0 py-0 d-sm-flex d-block justify-end align-center",
    "class": _vm.flatChrome || _vm.stitch ? 'modal-content-bottom--flat px-6 px-sm-8' : 'primary-ultralight-grey px-2 px-sm-6'
  }, [_vm._t("bottom")], 2) : _vm._e()], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }